module.exports = __webpack_public_path__ + "static/media/ic_photo.8c192938.svg";